import {useFeaturePermission} from '../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../schema-types/globalTypes';

export type ATRNaming = 'RTQ' | 'ATR';

export const useRTQ = () => {
  const canUseRisk = useFeaturePermission([
    GlobalPermissionEnum.can_access_risk_profile,
    GlobalPermissionEnum.can_access_risk_notes,
  ]);
  const atrName: ATRNaming = canUseRisk ? 'RTQ' : 'ATR';
  const vulnerabilityName = canUseRisk ? 'Vulnerability' : 'Resilience';

  return {
    canUseRisk,
    atrName,
    vulnerabilityName,
  };
};
